import { useEffect, useState } from 'react';

/**
 * Lit le panier localStorage (`dz_cart`) et expose :
 *  - cartSupplierIds : Set des supplier_id présents dans le panier
 *  - cartSubtotalBySupplier : { [supplier_id]: subtotal_en_DA }
 *
 * Se re-synchronise automatiquement sur :
 *  - événement custom `cart-changed` (dispatché par Cart.jsx, ProductDetail, etc.)
 *  - événement DOM `storage` (autre onglet)
 */
export const useCartSyncBySupplier = () => {
  const [cartSupplierIds, setCartSupplierIds] = useState(() => new Set());
  const [cartSubtotalBySupplier, setCartSubtotalBySupplier] = useState(() => ({}));

  useEffect(() => {
    const readCart = () => {
      try {
        const cart = JSON.parse(localStorage.getItem('dz_cart') || '[]');
        const ids = new Set();
        const subtotals = {};
        for (const it of cart) {
          const sid = it?.variant?.supplier_id;
          if (!sid) continue;
          ids.add(sid);
          const line = (it.variant.price || 0) * (it.qty || 0);
          subtotals[sid] = (subtotals[sid] || 0) + line;
        }
        setCartSupplierIds(ids);
        setCartSubtotalBySupplier(subtotals);
      } catch {
        setCartSupplierIds(new Set());
        setCartSubtotalBySupplier({});
      }
    };
    readCart();
    window.addEventListener('cart-changed', readCart);
    window.addEventListener('storage', readCart);
    return () => {
      window.removeEventListener('cart-changed', readCart);
      window.removeEventListener('storage', readCart);
    };
  }, []);

  return { cartSupplierIds, cartSubtotalBySupplier };
};
